import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import { Login } from './components/auth/Login';
export function AppRouter() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  useEffect(() => {
    // Check if user is authenticated
    const auth = localStorage.getItem('isAuthenticated') === 'true';
    setIsAuthenticated(auth);
  }, []);
  // Show loading state while checking auth
  if (isAuthenticated === null) {
    return <div className="min-h-screen bg-dark-900 flex items-center justify-center" data-id="element-15">
        <div className="text-center" data-id="element-16">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto mb-4" data-id="element-17"></div>
          <p className="text-gray-400 text-sm" data-id="element-18">Memuat sistem...</p>
        </div>
      </div>;
  }
  return <BrowserRouter data-id="element-19">
      <Routes data-id="element-20">
        <Route path="/login" element={!isAuthenticated ? <Login data-id="element-22" /> : <Navigate to="/" replace data-id="element-23" />} data-id="element-21" />
        <Route path="/" element={isAuthenticated ? <App data-id="element-25" /> : <Navigate to="/login" replace data-id="element-26" />} data-id="element-24" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-28" />} data-id="element-27" />
      </Routes>
    </BrowserRouter>;
}